import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { isDefined } from '@freelancer/utils';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingConfig } from './tracking.interface';
import { CustomTrackingEvent, TrackingEventData } from './tracking.model';

export interface LinkedInTrackingEvent {
  readonly conversion_currency?: string;
  readonly conversion_id?: LinkedInPixelTrackingEventConversionId;
  readonly conversion_type?: string;
  readonly conversion_url?: string;
  readonly conversion_value?: string | number;
  readonly order_id?: string | number;
  readonly tmsource?: string;
}

export enum LinkedInPixelTrackingEventConversionId {
  FREELANCER_SIGN_UP = 7251484,
  SEND_QUOTE = 7251492,
}

@Injectable()
export class LinkedInPixelTracking {
  private isEnabled = false;

  constructor(
    private ngZone: NgZone,
    @Inject(TRACKING_CONFIG) private config: TrackingConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isEnabled =
      isDefined(this.config.linkedInPixelId) &&
      isPlatformBrowser(this.platformId);
  }

  trackPageView(): void {
    if (!this.isEnabled) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.loadTrackingSnippet();
      window.lintrk('track', 'PageView');
    });
  }

  trackCustomEvent(payload: CustomTrackingEvent & TrackingEventData): void {
    if (!this.isEnabled || !isDefined(payload.linkedInEventData)) {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      this.loadTrackingSnippet();
      window.lintrk('track', payload.linkedInEventData);
    });
  }

  private loadTrackingSnippet(): void {
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    if (
      !window._linkedin_data_partner_ids.includes(this.config.linkedInPixelId)
    ) {
      window._linkedin_data_partner_ids.push(this.config.linkedInPixelId);
    }

    if (!window.lintrk) {
      window.lintrk = function lintrk(a: any, b: any) {
        window.lintrk.q.push([a, b]);
      };
      window.lintrk.q = [];
    }

    const s = document.getElementsByTagName('script')[0];
    const b = document.createElement('script');
    b.type = 'text/javascript';
    b.async = true;
    b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
    s.parentNode?.insertBefore(b, s);
  }
}
